// extracted by mini-css-extract-plugin
export default {"cannedReplyList":"cannedReplyList__RNVaXc08Ut0w"};